(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-cat-filter-template"]) return;
  try {
    
  window.onload = () => {
	
    $(document).on('change', '.ninja_filter_selector', function () {
      let filters = [];
      let urlPathParams = [];
      $('.ninja_filter_selector').each(function () {
        if( $(this).val() != '' ) {
          var dataSlug = $(this).find('option[value="'+$(this).val()+'"]').data('slug');
          urlPathParams.push(encodeURIComponent(dataSlug));
          filters.push($(this).data('name') + '=' + $(this).val());
        }
      });

	  let collectionURL = 'https://' + ninja_base_url + '/collections/' + ninja_collection_name + '/' + urlPathParams.join('+') + '?' + filters.join('&');
      if(current_tags.length > 0 && current_tags.indexOf("group") != -1) {
		 collectionURL = 'https://' + ninja_base_url + '/collections/' + ninja_collection_name + '/' + current_tags + urlPathParams.join('+') + '?' + filters.join('&');
 	    console.log(collectionURL);
      } 
   	
    });

	$(document).on('click', '.ninja_filter_radio_selector', function () {
      var isChecked = false;

      if( $(this).closest('li').hasClass('active') ) {

        isChecked =  false;
		$(this).closest('li').find('.ninja_filter_radio_selector').prop('checked', false);
		applyNinjaCFilter();
      }
    });

    $(document).on('change', '.ninja_filter_radio_selector', function () {
      applyNinjaCFilter();
    });

    function applyNinjaCFilter() {
      let filters = [];
      let urlPathParams = [];
      $('.ninja_filter_radio_selector:checked').each(function () {
        if( $(this).val() != '' ) {
          var dataSlug = $(this).val();
          dataSlug = dataSlug.replace('/collections/vendors','');
          urlPathParams.push(encodeURIComponent(dataSlug));

          filters.push($(this).data('name') + '=' + dataSlug);
        }
      });
	
	  if(urlPathParams.join('+').indexOf('%3F' ) != -1 ){
	   let location = urlPathParams.join('+').split('%3F'); 
	   urlPathParams = location[0];
	  }

      let collectionURL = 'https://' + ninja_base_url + '/collections/' + ninja_collection_name + '/'  +  urlPathParams + '?' + filters.join('&').replace('?','&') ;
      if(current_tags.length > 0  && current_tags.indexOf("group") != -1){
           collectionURL = 'https://' + ninja_base_url + '/collections/' + ninja_collection_name + '/' + current_tags +  urlPathParams + '?' + filters.join('&').replace('?','&') ;
      } 

      window.location.href = collectionURL;
    }
  };

var acc = document.getElementsByClassName("ninja_accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
  if( acc[i].classList.contains('active') ) {
    var panel = acc[i].nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
    
  }
}

// Clickable sidebar widgets on mobile screens
$(document).on('click', '.click-reveal', function () {
  if ( ($(document).width()) < 601) {
    $(this).next('.sidebar-panel').slideToggle('medium');
    $(this).children('.icon').toggleClass('rotate');
  }
});

function toggleSidebarWidget(windowSize) {
  if (windowSize > 600) {
    $(".sidebar-panel").css("display", "block");
  } else {
    $(".sidebar-panel").css("display", "none");
  }
}

$(document).ready(function() {
  const prevWidth = $(window).width(), prevHeight = $(window).height();
  toggleSidebarWidget( $(this).width() ); 
	  
  $(window).resize(function() {
	if($(window).width() != prevWidth || $(window).height() != prevHeight){
      toggleSidebarWidget( $(this).width() );
	}
  });
});
                           

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-filter-template"]) return;
  try {
    
  window.onload = () => {
  
    $(document).on('change', '.ninja_filter_selector', function () {
      let filters = [];
      let urlPathParams = [];
      $('.ninja_filter_selector').each(function () {
        if( $(this).val() != '' ) {
          var dataSlug = $(this).find('option[value="'+$(this).val()+'"]').data('slug');
          urlPathParams.push(encodeURIComponent(dataSlug));
          filters.push($(this).data('name') + '=' + $(this).val());
        }
      });
    let collectionURL = 'https://' + ninja_base_url + '/collections/' + ninja_collection_name + '/' + urlPathParams.join('+') + '?' + filters.join('&');
      
    window.location.href = collectionURL;
    });

  $(document).on('click', '.ninja_filter_radio_selector', function () {
      var isChecked = false;
      if( $(this).closest('li').hasClass('active') ) {
        isChecked =  false;
    $(this).closest('li').find('.ninja_filter_radio_selector').prop('checked', false);
    applyNinjaCFilter();
      }
    });
    $(document).on('change', '.ninja_filter_radio_selector', function () {
      applyNinjaCFilter();
    });
    function applyNinjaCFilter() {
      let filters = [];
      let urlPathParams = [];
      $('.ninja_filter_radio_selector:checked').each(function () {
        if( $(this).val() != '' ) {
          var dataSlug = $(this).val();
          urlPathParams.push(encodeURIComponent(dataSlug));
          filters.push($(this).data('name') + '=' + $(this).val());
        }
      });
      let collectionURL = 'https://' + ninja_base_url + '/collections/' + ninja_collection_name + '/' + urlPathParams.join('+') + '?' + filters.join('&');
      window.location.href = collectionURL;
    }

  
  };

var acc = document.getElementsByClassName("ninja_accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
  if( acc[i].classList.contains('active') ) {
    var panel = acc[i].nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
    
  }
}

  } catch(e) { console.error(e); }
})();
})();
